import { HdOption } from "../model/common-type";

// 表格行
export class TableColumn {
  label: string;  // 文本
  name: string;  // 字段名称
  value?: string | boolean | Array<string | Date> | null = null;  // 值 不传默认为null
  selectList?: Array<HdOption>;  // 控件为Select时，选项列表
  // 组件内部成员
  show?: boolean;
}

//
export class TableTotalOption {
  columnNumber: number; // 总列数
  insertIndex: number; // 插入下标
  insertName: string; // 插入字段
}
